module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-529-retro.cfa1c712.jpg";